/* PawLi — show the customer's uploaded pillow (line item property "_photo")
   as the cart line-item image, on the cart page AND the cart drawer.
   Non-invasive: no core template edited; it just swaps <img> src after render. */
(function () {
  let busy = false;

  async function apply() {
    if (busy) return;
    const rows = document.querySelectorAll('[data-key]');
    if (!rows.length) return;
    busy = true;
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      (cart.items || []).forEach((it) => {
        const props = it.properties || {};
        const url = props._photo || props['_photo'];
        if (!url) return;
        document
          .querySelectorAll('[data-key="' + it.key + '"] img')
          .forEach((img) => {
            if (img.getAttribute('src') === url) return;
            img.setAttribute('src', url);
            img.removeAttribute('srcset');
            img.style.objectFit = 'contain';
          });
      });
    } catch (e) {
      /* ignore */
    } finally {
      busy = false;
    }
  }

  function schedule() {
    clearTimeout(window.__pawliCartPhotoT);
    window.__pawliCartPhotoT = setTimeout(apply, 120);
  }

  document.addEventListener('DOMContentLoaded', schedule);
  // Cart drawer opens / AJAX cart re-renders replace the rows: re-apply.
  const mo = new MutationObserver(schedule);
  document.addEventListener('DOMContentLoaded', function () {
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
